import loadable from "@loadable/component";
import "devextreme/dist/css/dx.common.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Route, withRouter } from "react-router-dom";
import Auth from "../src/lib/auth";
import PLoadPanel from "./components/Common/PLoadPanel";
import { Login } from "./pages/Login";

const App = loadable(() => import("./App"), { fallback: <PLoadPanel visible /> });

const AppWrapper = (props) => {
  const [auth] = useState(new Auth(props.history));
  const [tokenRenewalComplete, setTokenRenewalComplete] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    auth.renewToken(() => setTokenRenewalComplete(true));
  }, [auth]);

  if (!tokenRenewalComplete) return "Loading...";

  if (props.location.pathname === "/login") {
    return <Route path="/login" render={(props) => <Login auth={auth} {...props} />} />;
  } else {
    return <App auth={auth} />;
  }
};

AppWrapper.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
};

export default withRouter(AppWrapper);
